import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ThemePalette} from "@angular/material/core";

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: DialogSetting) {
  }

  ngOnInit(): void {
  }

  submit(returnValue: any): void {
    this.dialogRef.close(returnValue)
  }

}

interface DialogSetting {
  message: string,
  options: Option[],
}

interface Option {
  label: string,
  color: ThemePalette,
  returnValue: any,
}
